<template>
    <div>
        <div class="kqf-card  mg10 search-box mt20">
            <el-form :inline="true" size="mini" :model="search" class="demo-form-inline">
                <el-form-item label="分类">
                    <el-select v-model="search.category_id" clearable placeholder="请选择">
                        <el-option
                        v-for="item in category_names"
                        :key="item.id"
                        :label="item.menu"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="kqf-card mg10 pd10 mt20" v-loading="loading"  style="min-width: 1100px">
            <el-table border :data="datas.list"  height="calc(100vh - 290px)">
                <el-table-column label="ID" width="80" prop="id" align="center"></el-table-column>
                <el-table-column label="分类名称" prop="category_name" align="center"></el-table-column>
                <el-table-column label="排序" prop="sort" align="center"></el-table-column>
                <el-table-column label="是否启用" align="center">
                    <template slot-scope="scope">
                        <el-switch @input="setIsqiyong(scope.row)" :value="scope.row.status" :active-value="1" :inactive-value="2">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.create_time}} -- {{scope.row.create_ip}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-edit" type="primary" size="medium" style="margin-right:20px" @click="geteditDatas(scope.row)">编辑</el-button>
                            <el-popconfirm
                                    title="这是一段内容确定删除吗？"
                                    @confirm="handleDelete(scope.row)">
                                <el-button icon="el-icon-delete" type="danger" slot="reference" size="medium">删除</el-button>
                                
                            </el-popconfirm>
                       
                    </template>
                </el-table-column>
            </el-table>
           
            <div class="flex space mt10">
                 <div>
                
                   <el-button type="primary" icon="el-icon-plus" size="medium" @click="createEnv()">新增分类</el-button>
                 
                </div>
                <div>
                    <el-pagination
                            @current-change="getList"
                            background
                            :page-size="datas.limit"
                            layout="total, prev, pager, next"
                            :total="datas.count">
                    </el-pagination>
                </div>
            </div>
        </div>
           <el-dialog width="600px"   title="添加文章分类"  :visible.sync="createDialog">
            <el-form label-width="100px" size="small" v-loading="loading">
                    <el-form-item label="分类名：" label-width="100px" required>
                        <el-input v-model="form.category_name" style="width:215px"></el-input>
                    </el-form-item>
                    <el-form-item label="上级分类：" label-width="100px" required>
                        <el-select v-model="form.category_id" clearable placeholder="请选择">
                            <el-option label="无上级" :value="0"></el-option>
                            <el-option
                                    v-for="item in category_names"
                                    :key="item.id"
                                    :label="item.menu"
                                    :value="item.id"
                                    >
                            </el-option>
                        </el-select>
                    </el-form-item>
<!--                    <el-form-item label="图标：" >-->
<!--                        <upload-one w="80px" h="80px" v-model="form.icon"></upload-one>-->
<!--                    </el-form-item>-->
                    <el-form-item label="启用：" label-width="100px" required>
                        <el-switch v-model="form.status" active-value="1" inactive-value="2"></el-switch>
                    </el-form-item>
                    <el-form-item label="排序：" label-width="100px" required>
                        <el-input-number v-model="form.sort"  :min="0" ></el-input-number>
                    </el-form-item>
                     <el-form-item>
                    <el-button type="primary" size="medium" style="margin:20px 0 0px 0px" @click="createArticleCategory">保存</el-button>
                </el-form-item>
            </el-form>
          </el-dialog>

            <el-dialog width="500px"   title="编辑文章分类"   :visible.sync="editDialog">
            <el-form label-width="80px" size="small"  v-loading="editLoading">
                 <el-form ref="form"  label-width="80px">
                    <el-form-item label="分类名：" label-width="100px" required>
                        <el-input v-model="form.category_name" style="width:215px"></el-input>
                    </el-form-item>
                    <el-form-item label="上级分类：" label-width="100px" required>

                        <el-select v-model="form.category_id" clearable placeholder="请选择" >
                            <el-option label="无上级" label-width="100px" :value="0"></el-option>
                            <el-option
                                    v-for="item in category_names"
                                    :key="item.id"
                                    :label="item.menu"
                                    :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="启用：" label-width="100px" required>
                        <el-switch v-model="form.status" :active-value="1" :inactive-value="2"></el-switch>
                    </el-form-item>
                    <el-form-item label="排序：" label-width="100px" required>
                        <el-input-number v-model="form.sort"  :min="0" ></el-input-number>
                    </el-form-item>
                      <el-form-item>
                    <el-button type="primary" size="medium" style="margin:20px 0 0px 20px" @click="editsArticleCategory">保存</el-button>
                </el-form-item>
                </el-form>
            </el-form>
        </el-dialog>

        </div>
</template>
<script>
    import UploadOne from "../../../components/upload/UploadOne";
    import {articleCategoryList,getArticleCategory,deleteArticleCategory,isqiyongArticleCategory,createArticleCategory,editsArticleCategory,getEditData} from "../../../request/api/article/category";
    export default {
        data() {
            components: {UploadOne}
            return {
                datas: [],
                search: this.getSearch(),
                category_names:[],
                loading: false,
                createDialog:false,
                createLoading:false,
                editLoading:false,
                editDialog:false,
                 form:{
                    category_name:'',
                    category_id: '',
                    // icon:'',
                    sort:'0',
                    status:'1',
                    id:'',
                },
            }
        },
        created() {
            this.getList();
            this.getCategory_names();
        },
        methods: {
            getSearch(){
                return{
                    category_id: '',
                    page:1,
                }
            },
            //是否启用
            setIsqiyong(row){
                this.loading = true;
                isqiyongArticleCategory({id:row.id}).then(() => {
                    row.status = row.status == 2 ? 1 : 2;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            },

            getList(page) {
                this.search.page = page;
                this.loading = true;
                articleCategoryList({
                    page: page,
                    category_id: this.search.category_id,
                }).then(res => {
                    this.datas = res;
                    console.log(this.datas);
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            onSubmit() {
                this.getList();
            },
            //获取分类
            getCategory_names() {
                getArticleCategory({}).then(res => {
                    this.category_names = res.datas;

                }).catch(() => {

                })
            },
            handleChange(category_name) {
                this.formInline.category_id = category_name[1] || category_name[0];
            },
            //删除
            handleDelete(row) {
                this.loading = true;
                deleteArticleCategory({id:row.id}).then(() => {
                    //最后一页无数据 向上翻页
                    if (this.datas.list.length <= 1 && this.search.page > 1) {
                        this.search.page -= 1;
                    }
                    this.getList(this.search.page);
                }).catch(() => {
                    this.loading = false;
                })
            },
            //点击添加报价分类
            createEnv(row){
                this.form = {}
                this.createDialog=true;
                this.createForm=JSON.parse(JSON.stringify(row));
            },
             createArticleCategory(){
                this.loading = true;
                createArticleCategory({
                    category_name:this.form.category_name,
                    category_id:this.form.category_id,
                    // icon:this.form.icon,
                    sort:this.form.sort,
                    status:this.form.status,
                }).then(() => {
                    this.loading = false;
                    this.$message.success("操作成功");
                    setTimeout(() =>{
                        this.getList();
                         this.createDialog=false
                    },500);
                }).catch(() => {
                    this.loading = false;
                })
            },

            geteditDatas(row){
                console.log(row.id)
                this.editDialog=true;
                getEditData({
                    id:row.id,
                }).then(res => {
                     console.log(res)
                      this.form.category_name = res.editData.category_name;
                       this.form.category_id = res.editData.parent_id;
                       this.form.icon = res.editData.icon;
                       this.form.sort = res.editData.sort;
                       this.form.status = res.editData.status;
                       this.form.id = res.editData.id
                }).catch(() => {
                    this.loading = false;
                })
            },
             editsArticleCategory(){
                 console.log(this.form.id)
                this.loading = true;
                editsArticleCategory({
                    id:this.form.id,
                    category_name:this.form.category_name,
                    category_id:this.form.category_id,
                    sort:this.form.sort,
                    status:this.form.status,
                }).then((res) => {
                    console.log(res)
                    this.loading = false;
                    this.$message.success("操作成功");
                    setTimeout(() =>{
                         this.getList();
                         this.editDialog = false
                         this.form = ''
                    },500);
                }).catch(() => {
                    this.loading = false;
                    this.form = ''
                })
            },
        }
    }
</script>

<style scoped>

</style>